import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ConsumerInterface, ConsumerMetaInterface } from '@interface/consumer/consumer.interface';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { baseReducerActions } from '@util/data/base-reducer-actions';
import { mapifyPayload } from '@util/store/mapify-payload';

import { initialConsumersState } from './consumers.initial-state';

export const consumersSlice = createSlice({
  name: 'consumers',
  initialState: initialConsumersState,
  reducers: {
    ...baseReducerActions(initialConsumersState),
    setData: (state, { payload }: PayloadAction<ResponseDataInterface<ConsumerInterface[]>>) => {
      state.data = mapifyPayload(payload.data);
    },
    setConsumer: (state, { payload }: PayloadAction<ResponseDataInterface<ConsumerInterface>>) => {
      state.data[payload.data.id] = payload.data;
    },
    setAccess: (state, { payload }: PayloadAction<ConsumerMetaInterface>) => {
      state.meta.accessToken = payload.accessToken;
    },
    resetAccess: (state) => {
      state.meta = initialConsumersState.meta;
    },
    removeConsumer: (state, { payload }: PayloadAction<string>) => {
      state.data = Object.keys(state.data).reduce(
        (consumers, key) =>
          key === payload
            ? consumers
            : {
                ...consumers,
                [key]: state.data[key],
              },
        {},
      );
    },
  },
});

export const consumersActions = consumersSlice.actions;
